import { AppShell, Box, Group, Image, Loader, Text, useMantineColorScheme } from "@mantine/core";

/** Full-page loading shell shown by route guards while auth/role resolves.
 *  Mirrors the real header position so the logo never jumps. */
export function LoadingScreen() {
    const { colorScheme } = useMantineColorScheme();
    const isDark = colorScheme === "dark";

    return (
        <AppShell header={{ height: 60 }} padding="md">
            <AppShell.Header>
                <Box
                    component="header"
                    style={{
                        height: 60,
                        padding: "0 1rem",
                        borderBottom: `1px solid ${isDark ? "var(--mantine-color-dark-4)" : "var(--mantine-color-gray-3)"}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: isDark ? undefined : "var(--mantine-color-gray-0)",
                    }}
                >
                    <Group gap="sm" align="center" style={{ height: "100%" }}>
                        <Box style={{ height: "100%", display: "flex", alignItems: "center" }}>
                            <Image
                                src={isDark ? "/logo_white.svg" : "/logo.svg"}
                                style={{ width: "100%", height: "100%", maxWidth: 200, maxHeight: 50 }}
                                alt="Sopra Steria Logo"
                                height={50}
                                fit="contain"
                                fallbackSrc="https://placehold.co/200x50?text=Logo"
                            />
                        </Box>
                        <Group gap="xs" align="center" ml="md">
                            <Loader size="xs" color="brand" />
                            <Text size="sm" c="dimmed">Loading…</Text>
                        </Group>
                    </Group>
                </Box>
            </AppShell.Header>
        </AppShell>
    );
}
